<template>
  <v-dialog v-model="dialogLocal" max-width="800px" width="100%">
    <v-card>
      <v-card-title>{{ lang.add_coupon }}</v-card-title>
      <v-divider class="ma-0"></v-divider>
      <v-container grid-list-sm class="pa-4 add-licence-dialog">
        <v-row>
          <v-col>
            <v-form :v-model="true" ref="form" lazy-validation>
              <v-select
                :rules="[(v) => !!v || lang.plan_required]"
                v-model="addingPlanID"
                item-text="nickname"
                item-value="id"
                :items="plans"
                prepend-icon="fa-light fa-file-contract"
                :label="lang.plan"
              >
                <template slot="selection" slot-scope="data">{{
                  data.item.nickname
                }}</template>
                <template slot="item" slot-scope="data">{{
                  data.item.nickname
                }}</template>
              </v-select>
              <v-text-field
                :counter="40"
                :rules="[
                  (v) => !!v || lang.name_required,
                  (v) => v.length <= 40 || lang.exceeded_allowed_max,
                ]"
                :label="lang.coupon_name"
                v-model="addingCouponName"
                prepend-icon="fa-light fa-note"
              ></v-text-field>
              <v-text-field
                :counter="40"
                :rules="[(v) => v.length <= 40 || lang.exceeded_allowed_max]"
                :label="lang.optional_note"
                :hint="lang.coupon_note_hint"
                v-model="addingNote"
                prepend-icon="fa-light fa-memo-pad"
              ></v-text-field>
              <v-text-field
                :rules="[(v) => !!v || lang.qty_required]"
                :label="lang.num_displays"
                type="number"
                min="1"
                :value="addingCouponQty"
                v-model="addingCouponQty"
                :suffix="unitPriceText"
                prepend-icon="fa-light fa-tv"
              ></v-text-field>
              <span class="subtitle-1" v-if="totalPriceText != ''">{{
                lang.coupon_total_cost
              }}</span>
              <span class="title ml-1 orange--text">{{ totalPriceText }}</span>
            </v-form>
          </v-col>
          <v-col cols="6">
            <priceDetails v-if="currentPlan" :plan="currentPlan" />
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="ma-0"></v-divider>
      <v-card-actions>
        <v-btn text color="secondary" @click="dialogLocal = false">{{
          lang.cancel
        }}</v-btn>
        <v-btn text color="primary" @click="addCoupon">{{
          lang.add_coupon
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
const coupons = require("./coupons.js").coupons;
import priceDetails from "./price_details";

export default {
  data() {
    return {
      addingPlanID: "",
      addingCouponName: "",
      addingNote: "",
      addingCouponQty: 1,
    };
  },
  components: {
    priceDetails,
  },
  props: {
    dialog: Boolean,
    plans: Array,
  },
  watch: {
    dialog: function(val) {
      if (!val) return;
      for (var i in this.plans) {
        this.addingPlanID = this.plans[i].id;
      }
      this.addingCouponQty = 1;
      this.addingCouponName = "";
      this.addingNote = "";
    },
  },
  computed: {
    ...mapState(["lang"]),
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
    currentPlan: function() {
      for (var i in this.plans) {
        if (this.plans[i].id == this.addingPlanID) {
          return this.plans[i];
        }
      }
      return false;
    },
    unitPriceText: function() {
      if (!this.currentPlan) return "";
      if (this.addingCouponQty == 0 || this.unitPrice == 0) return "";
      return (
        this.unitPrice +
        " " +
        this.getCurrency(this.currentPlan.currency) +
        " " +
        this.lang.per_licence
      );
    },
    totalPriceText: function() {
      if (!this.currentPlan) return "";
      if (this.addingCouponQty == 0 || this.unitPrice == 0) return "";
      return (
        this.unitPrice * this.addingCouponQty +
        " " +
        this.getCurrency(this.currentPlan.currency)
      );
    },
    unitPrice: function() {
      if (!this.addingCouponQty) return 0;
      if (this.addingCouponQty == "") return 0;
      var plan = this.currentPlan;
      var last = 0;
      if (plan.tiers && plan.tiers.length > 0) {
        for (var i in plan.tiers) {
          if (plan.tiers[i].up_to == 0) {
            last = plan.tiers[i].unit_amount;
          }
          if (this.addingCouponQty <= plan.tiers[i].up_to) {
            return plan.tiers[i].unit_amount / 100;
          }
        }
      } else {
        return plan.amount / 100;
      }

      return last / 100;
    },
  },
  mounted() {},
  methods: {
    getCurrency(currency) {
      switch (currency) {
        case "usd":
          return this.lang.dollars;
        case "aud":
          return this.lang.au_dollars;
      }
      return currency;
    },
    added(coupon) {
      this.$emit("added", coupon);
    },
    addCoupon() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.$emit("adding");
      this.dialogLocal = false;
      coupons.add(
        this.addingPlanID,
        this.addingCouponName,
        this.addingCouponQty,
        this.addingNote,
        this.added
      );
    },
  },
};
</script>
<style>
.add-licence-dialog .v-input__prepend-outer {
  margin-right: 20px;
}
</style>
